import { getStore } from '~/mobx/AppStore';

const onChangeRegionForCopy = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const { candidateStore } = getStore();

    candidateStore.setSelectedRegionIdForCopy(event.target.value);
    candidateStore.setIsCopyingCandidateSuccess(false);
};

export default onChangeRegionForCopy;
